import { render, staticRenderFns } from "./ListeningPhonics1Form.vue?vue&type=template&id=1067b089&"
import script from "./ListeningPhonics1Form.vue?vue&type=script&lang=js&"
export * from "./ListeningPhonics1Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports